import { analytics } from '@/features/analytics/events'
import { useLanguages } from '@/features/profile/api/dictionaries'
import { Button, Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMissionsUrl } from '../context/MissionsUrlProvider'

type MissionLockedByLanguagesProps = {
  projectId: string
  title: string
  description: string
  languages: string[]
}

export const MissionLockedByLanguages = ({
  projectId,
  title,
  description,
  languages
}: MissionLockedByLanguagesProps) => {
  const { options: dictionary } = useLanguages()
  const { missionsUrl } = useMissionsUrl()
  const navigate = useNavigate()

  useEffect(() => {
    analytics.missionOnboardingLanguageMismatch(projectId)
  }, [])

  const resolveLanguageName = (code: string): string => {
    const match = dictionary.find((item) => item.code === code || item.iso1 === code)
    return match?.name ?? code
  }

  const requiredLanguagesText = Array.from(new Set(languages.map(resolveLanguageName))).join(', ')

  return (
    <div className="flex flex-col items-center justify-center gap-4 text-center">
      <div className="flex w-full flex-col items-center justify-center gap-2 border-b border-gray-100 pb-7">
        <div className="text-subtitle text-gray-80 font-semibold">{title}</div>
        <Text type="body3-regular" className="text-gray-80 max-w-[500px]">
          {description}
        </Text>
      </div>
      <Text type="h5" className="text-gray-70 mt-2">
        <Trans>Mission Locked</Trans>
      </Text>
      <div className="flex flex-col items-center justify-center">
        <Text type="body1-regular" className="text-gray-80">
          <Trans>
            This mission is only available to users who meet the required language criteria:{' '}
            <strong className="text-gray-70">{requiredLanguagesText}</strong>. Your current profile does not match these
            requirements.
          </Trans>
        </Text>
      </div>
      <Button size="small" variant="bordered" onClick={() => navigate(missionsUrl)} className="mt-2">
        <Trans>Back to Missions</Trans>
      </Button>
    </div>
  )
}
